import React, { createContext, useContext, useState, useCallback } from 'react';

// Create the context
const HealthLoadingContext = createContext();

// Custom hook to use the context
export const useHealthLoading = () => {
  const context = useContext(HealthLoadingContext);
  if (!context) {
    throw new Error('useHealthLoading must be used within a HealthLoadingProvider');
  }
  return context;
};

// Context provider component
export const HealthLoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Start loading
  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  // Stop loading
  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  // Wrapper function for API calls with automatic loading state
  const withLoading = useCallback(
    async (apiCall) => {
      try {
        startLoading();
        const result = await apiCall();
        return result;
      } finally {
        stopLoading();
      }
    },
    [startLoading, stopLoading]
  );

  const value = {
    isLoading,
    startLoading,
    stopLoading,
    withLoading
  };

  return <HealthLoadingContext.Provider value={value}>{children}</HealthLoadingContext.Provider>;
};
